<template>
  <div>
    <div class="heading">{{ $t('event_electricity.page_title') }}</div>
    <FilterProductButton v-model="journeySelection" :valuesList="valuesList" />
    <NewGlassCard :title="selectedJourneyLabel">
      <template v-slot:back-button>
        <v-btn class="back-button mb-6" @click="goOnePageBack">
          <v-icon color="#6E6E6E">mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <ConstructionAndEventPowerOverviewComponent
        :journey-selection="journeySelection"
        @journey-change="journeySelection = $event"
      />
    </NewGlassCard>
  </div>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import FilterProductButton from '../components/design-components/FilterProductButton.vue';
import { CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES } from '../helpers/constructionAndEventPowerJourneys';
import { getCommissioningPipelineSummary } from '../services/CommissioningService';
import ConstructionAndEventPowerOverviewComponent from '../components/construction-and-event-power-overview-component/ConstructionAndEventPowerOverviewComponent.vue';

export default {
  name: 'ConstructionAndEventPowerPage',
  components: {
    ConstructionAndEventPowerOverviewComponent,
    NewGlassCard,
    FilterProductButton,
  },
  data() {
    return {
      journeySelection: CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES.includes(
        this.$route.query.journey_type
      )
        ? this.$route.query.journey_type
        : 'all',
      journeyCounts: {},
    };
  },
  created() {
    this.loadJourneyCounts();
  },
  computed: {
    valuesList() {
      return [
        {
          id: 'all',
          label: this.$t('event_electricity.all_orders'),
          value: CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES.reduce(
            (total, journey) => total + (this.journeyCounts[journey] || 0),
            0
          ),
        },
        {
          id: 'SITE_ELECTRIC_METER_ORDER',
          label: this.$t('clerk_orders_overview_table.construction_power'),
          value: this.journeyCounts.SITE_ELECTRIC_METER_ORDER,
        },
        {
          id: 'EVENT_ELECTRIC_METER_ORDER',
          label: this.$t('event_electricity.product'),
          value: this.journeyCounts.EVENT_ELECTRIC_METER_ORDER,
        },
      ];
    },
    selectedJourneyLabel() {
      return this.valuesList.find((item) => item.id === this.journeySelection)
        .label;
    },
  },
  methods: {
    async loadJourneyCounts() {
      const summaries = await Promise.all(
        CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES.map((journey) =>
          getCommissioningPipelineSummary('', [journey])
        )
      );
      this.journeyCounts = Object.fromEntries(
        CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES.map((journey, index) => [
          journey,
          summaries[index]?.count_orders || 0,
        ])
      );
    },
    goOnePageBack() {
      this.$router.push(this.$store.getters.getPreviousPage || '/');
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 50px;
  margin-bottom: 0;
}

.back-button {
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  height: 35px !important;
  width: 90px;
  box-shadow: none;
  margin-right: 30px;
}
</style>
